/*
 * Project: Dynamedics Portal Web
 * Created Date: Sunday May 16th 2021
 * Author: Nalinda Wijayagunawardhane
 * -----
 * Last Modified: Sunday May 16th 2021 1:16:59 pm
 * Modified By: Nalinda Wijayagunawardhane at <nwijayagunawardhane@mitrai.com>
 * -----
 * Copyright (c) 2021 Mitra Sparks
 * -----
 * HISTORY:
 */

import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
// guards
import AuthGuard from '../guards/AuthGuard';
// layouts
import HomeLayout from 'src/layouts/navigation';
import { PATH_DASHBOARD, PATH_PAGE } from './paths';

// ----------------------------------------------------------------------

const DashboardRoutes = {
  path: '*',
  guard: AuthGuard,
  layout: HomeLayout,
  routes: [
    {
      exact: true,
      path: '/',
      component: () => <Redirect to={PATH_DASHBOARD.general.dashboard.root} />
    },
    // GENERAL
    // ----------------------------------------------------------------------
    {
      exact: true,
      path: PATH_DASHBOARD.general.dashboard.root,
      component: lazy(() => import('../views/general/GeneralDashboard'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.environment.root,
      component: lazy(() => import('../views/general/GeneralEnvironment'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.social.root,
      component: lazy(() => import('../views/general/GeneralSocial'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.governance.root,
      component: lazy(() => import('../views/general/GeneralGovernance'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.suppliers.root,
      component: lazy(() => import('../views/general/GeneralSuppliers'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.marketplace.root,
      component: lazy(() => import('../views/general/GeneralMarketplace'))
    },
    // {
    //   exact: true,
    //   path: PATH_DASHBOARD.general.insightsProductivity,
    //   component: lazy(() => import('../views/GeneralInsightsProductivity'))
    // },
    // {
    //   exact: true,
    //   path: PATH_DASHBOARD.general.insightsBookmarks,
    //   component: lazy(() => import('../views/ManagementInsightsReport'))
    // },
    // {
    //   exact: true,
    //   path: PATH_DASHBOARD.general.insightsSupplier,
    //   component: lazy(() => import('../views/GeneralInsightsSupplier'))
    // },
    {
      exact: true,
      path: PATH_DASHBOARD.root,
      component: () => <Redirect to={PATH_DASHBOARD.general.dashboard.root} />
    },
    // MANAGEMENT : VIEWS
    // ----------------------------------------------------------------------
    {
      exact: true,
      path: PATH_DASHBOARD.management.reports,
      component: lazy(() =>
        import('../views/management/ManagementInsightsReport')
      )
    },

    // MANAGEMENT : USER
    // ----------------------------------------------------------------------
    {
      exact: true,
      path: PATH_DASHBOARD.management.users,
      component: lazy(() => import('../views/management/ManagementUsers'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.newUser,
      component: lazy(() => import('../views/UserAddEdit'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.editUser,
      component: lazy(() => import('../views/UserAddEdit'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.user.account,
      component: lazy(() => import('../views/UserAccount'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.user.root,
      component: () => <Redirect to={PATH_DASHBOARD.user.account} />
    },
    {
      exact: true,
      path: PATH_DASHBOARD.user.management,
      component: () => <Redirect to={PATH_PAGE.comingSoon} />
    },

    // MANAGEMENT : CONTENT
    {
      exact: true,
      path: PATH_DASHBOARD.management.content,
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
      component: lazy(() => import('../views/management/ManagementContent'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.newDigitalResource,
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
      component: lazy(() =>
        import('../components/management/content/DigitalResourceAddEdit')
      )
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.editDigitalResource,
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
      component: lazy(() =>
        import('../components/management/content/DigitalResourceAddEdit')
      )
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.newNews,
      component: lazy(() => import('../views/common/NewsAddEdit'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.editNews,
      component: lazy(() => import('../views/common/NewsAddEdit'))
    },

    {
      exact: true,
      path: PATH_DASHBOARD.management.newContainer,
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
      component: lazy(() =>
        import('../components/management/content/ContainerAddEdit')
      )
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.editDigitalResourceContainer,
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
      component: lazy(() =>
        import('../components/management/content/ContainerAddEdit')
      )
    },
    // MANAGEMENT : INTEREST GROUPS
    {
      exact: true,
      path: PATH_DASHBOARD.management.interestGroups,
      component: lazy(() =>
        import('../views/management/ManagementInterestGroups')
      )
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.newInterestGroup,
      component: lazy(() =>
        import('../components/management/interest-groups/InterestGroupAddEdit')
      )
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.editInterestGroup,
      component: lazy(() =>
        import('../components/management/interest-groups/InterestGroupAddEdit')
      )
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.interestGroupDetail,
      component: lazy(() =>
        import('../views/management/ManagementInterestGroupDetail')
      )
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
    },
    // MANAGEMENT : COMMUNICAION
    {
      exact: true,
      path: PATH_DASHBOARD.management.communication,
      component: lazy(() =>
        import('../views/management/ManagementCommunication')
      )
    },

    // MANAGEMENT : SURVEYS
    {
      exact: true,
      path: PATH_DASHBOARD.management.surveys,
      // component: lazy(() => import('../views/ManagementSurveys'))
      component: () => <Redirect to={PATH_PAGE.comingSoon} />
    },
    // MANAGEMENT : PLATFORM SETTINGS
    {
      exact: true,
      path: PATH_DASHBOARD.management.platformSettings,
      component: lazy(() => import('../views/management/ManagementSettings'))
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
    },
    // MANAGEMENT : Data Sets
    {
      exact: true,
      path: PATH_DASHBOARD.management.dataSetManagement,
      component: lazy(() => import('../views/management/ManagementDataSet.js'))
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
    },
    // MANAGEMENT : Integrated Reports
    {
      exact: true,
      path: PATH_DASHBOARD.management.integratedReports,
      component: lazy(() => import('../views/general/GeneralGovernance.js'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.newIntegratedReport,
      component: lazy(() =>
        import(
          '../components/management/integrated-reports/IntegratedReportAddEdit.js'
        )
      )
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.editIntegratedReport,
      component: lazy(() =>
        import(
          '../components/management/integrated-reports/IntegratedReportAddEdit.js'
        )
      )
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.reviewIntegratedReport,
      component: lazy(() =>
        import(
          '../components/management/integrated-reports/IntegratedReportAddEdit.js'
        )
      )
    },
    {
      exact: true,
      path: PATH_DASHBOARD.management.generateIntegratedReport,
      component: lazy(() =>
        import(
          '../components/management/integrated-reports/IntegratedReportAddEdit.js'
        )
      )
    },
    // MANAGEMENT : Data Sets Upload
    {
      exact: true,
      path: PATH_DASHBOARD.management.uploadDataSets,
      component: lazy(() =>
        import('../components/management/data-sets/esg/DataSetUpload.js')
      )
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
    },
    // MANAGEMENT : PARTNERS
    {
      exact: true,
      path: PATH_DASHBOARD.management.suppliers,
      component: lazy(() => import('../views/general/GeneralSuppliers.js'))
    },
    // MANAGEMENT : Events
    {
      exact: true,
      path: PATH_DASHBOARD.management.events,
      component: lazy(() =>
        import('../views/management/ManagementSupplierEvents.js')
      )
    },
    // MANAGEMENT : BETA FEATURES
    {
      exact: true,
      path: PATH_DASHBOARD.beta.dataSetManagement.root,
      component: lazy(() =>
        import('../views/beta/data-sets/ManagementDataSetBeta.js')
      )
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
    }, // MANAGEMENT : BETA FEATURES DATA SETS
    {
      exact: true,
      path: PATH_DASHBOARD.beta.dataSetManagement.uploadDataSetsBeta,
      component: lazy(() =>
        import('../views/beta/data-sets/DataSetUploadBeta.js')
      )
      // component: () => <Redirect to={PATH_PAGE.comingSoon} />
    },

    // APP : CALENDAR
    // ----------------------------------------------------------------------
    {
      exact: true,
      path: PATH_DASHBOARD.calendar,
      component: lazy(() => import('../views/common/Calendar'))
    },

    // ----------------------------------------------------------------------

    {
      component: () => <Redirect to="/404" />
    }
  ]
};

export default DashboardRoutes;
